import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import MintUI from 'mint-ui'

Vue.use(Router)
Vue.use(MintUI)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PhilipsHomeAccess',
      component: () => import('../view/download/index'),
      meta: {
        title: 'Philips Home Access'
      }
    },
    {
      path: '/motorola',
      name: 'motorola',
      component: () => import('../view/download/motorola'),
      meta: { title: 'Motorola Home Security' }
    },
    {
      path: '/teeho',
      name: 'teeho',
      component: () => import('../view/download/teeho'),
      meta: { title: 'Teeho Home Security' }
    },
    {
      path: '/share/*',
      name: 'share',
      component: () => import('../view/share/share')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('../view/share/share')
    },
    {
      path: '/revolo_privacy_term',
      name: 'privacyTerm',
      component: () => import('../view/userAgreement/revolo_privacy_term')
    },
    {
      path: '/revolo_user_term',
      name: 'userTerm',
      component: () => import('../view/userAgreement/revolo_user_term')
    },
    {
      path: '/alexa',
      name: 'alexa',
      component: () => import('../view/alexa/alexa')
    },
    {
      path: '/download',
      name: 'revolo',
      component: () => import('../view/download/revolo')
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('../view/faq/Faq')
    },
    {
      path: '/faq/questionList',
      name: 'questionList',
      component: () => import('../view/faq/QuestionList')
    },
    {
      path: '/faq/questionDetails',
      name: 'questionDetails',
      component: () => import('../view/faq/QuestionDetails')
    },
    // 添加操作手册pdf路由 放在最后
    {
      path: '/installation/',
      name: 'installation',
      component: () => import('../view/pdf/installation')
    },
    {
      path: '/installation/list',
      name: 'installation',
      component: () => import('../view/pdf/installation')
    },
    // pdf-reader
    {
      path: '/installation/:model/:language',
      name: 'installation',
      component: () => import('../view/pdf/pdf-reader')
    },
    // legal
    {
      path: '/legal/philips_privacy_term_en',
      name: 'philips_privacy_term_en',
      component: () => import('../view/legal/philips_privacy_term_en.vue')
    },
    {
      path: '/legal/philips_privacy_term_es',
      name: 'philips_privacy_term_es',
      component: () => import('../view/legal/philips_privacy_term_es.vue')
    },
    {
      path: '/legal/philips_user_term_en',
      name: 'philips_user_term_en',
      component: () => import('../view/legal/philips_user_term_en.vue')
    },
    {
      path: '/legal/philips_user_term_es',
      name: 'philips_user_term_es',
      component: () => import('../view/legal/philips_user_term_es.vue')
    },
    {
      path: '/legal/motorola_privacy_term_en',
      name: 'motorola_privacy_term_en',
      component: () => import('../view/legal/motorola_privacy_term_en.vue'),
      meta: { title: 'Motorola Home Security' }
    },
    {
      path: '/legal/motorola_privacy_term_zh_CN',
      name: 'motorola_privacy_term_zh_CN',
      component: () => import('../view/legal/motorola_privacy_term_zh_CN.vue'),
      meta: { title: 'Motorola Home Security' }
    },
    {
      path: '/legal/motorola_user_term_en',
      name: 'motorola_user_term_en',
      component: () => import('../view/legal/motorola_user_term_en.vue'),
      meta: { title: 'Motorola Home Security' }
    },
    {
      path: '/legal/motorola_user_term_zh_CN',
      name: 'motorola_user_term_zh_CN',
      component: () => import('../view/legal/motorola_user_term_zh_CN.vue'),
      meta: { title: 'Motorola Home Security' }
    },
    {
      path: '/legal/teeho_privacy_term_en',
      name: 'teeho_privacy_term_en',
      component: () => import('../view/legal/teeho_privacy_term_en.vue'),
      meta: { title: 'Teeho Home Security' }
    },
    {
      path: '/legal/teeho_privacy_term_zh_CN',
      name: 'teeho_privacy_term_zh_CN',
      component: () => import('../view/legal/teeho_privacy_term_zh_CN.vue'),
      meta: { title: 'Teeho Home Security' }
    },
    {
      path: '/legal/teeho_user_term_en',
      name: 'teeho_user_term_en',
      component: () => import('../view/legal/teeho_user_term_en.vue'),
      meta: { title: 'Teeho Home Security' }
    },
    {
      path: '/legal/teeho_user_term_zh_CN',
      name: 'teeho_user_term_zh_CN',
      component: () => import('../view/legal/teeho_user_term_zh_CN.vue'),
      meta: { title: 'Teeho Home Security' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js